import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type ApiError = Static<typeof ApiErrorSchema>;

/**
 * This is the default error schema for Fastify.
 * The schema is currently not exposed from the Fastify dependency and
 * there is no way of setting the default error schema yourself without adding it to every route.
 */
export const ApiErrorSchema = Type.Object({
  error: Type.String(),
  code: Type.String(),
  message: Type.String(),
  statusCode: Type.Number(),
});
